import _ from 'underscore';
import PropTypes from 'prop-types';
import React, { useContext, useState } from 'react';
import { GoalPropType } from '@bingads-webui-campaign-react/auto-goal-creation-wizard-utils';
import { updateGoal } from '@bingads-webui-campaign-react/auto-goal-data-repository';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { getMessageFromErrors } from '@bingads-webui-campaign-react/conversion-wizard-components';

import { GoalDetailSettingDrawer } from './goal-details-setting-drawer';
import { generateAddOrEditGoalPayload } from './helper';

export const GoalDetailSettingEditDrawer = ({
  activity,
  goal,
  isOpen,
  isReadOnly,
  serverContext,
  setGoal,
  setIsOpen,
  restoreFocusSourceAttributes = {},
}) => {
  const i18n = useContext(I18nContext);
  const { Id: aid, AdvertiserCustomerID: cid } = serverContext.CurrentAccount;
  const [message, setMessage] = useState(null);
  const defaultErrorMessageEdit = i18n.getString(_TL_('Sorry, an error occurred while editing this goal.'));

  const setGoalInternal = (draftGoal) => {
    const editPayloads = generateAddOrEditGoalPayload([draftGoal]);

    updateGoal(draftGoal.Id, { ...editPayloads[0] }, cid, aid)
      .then((result) => {
        activity.trace(`[GoalDetailSettingEditDrawer] setGoalInternal draftGoal  ${JSON.stringify(result)}`);
        setGoal(draftGoal);
        setIsOpen(false);
      })
      .catch(({ errors }) => {
        if (errors) {
          const errorMessage = getMessageFromErrors(i18n, errors);
          setMessage(errorMessage);
        } else {
          setMessage(defaultErrorMessageEdit);
        }
      });
  };

  return (
    <GoalDetailSettingDrawer
      accountName={serverContext && serverContext.CurrentAccount.Title}
      goal={goal}
      isOpen={isOpen}
      isReadOnly={isReadOnly}
      message={message}
      setGoal={setGoalInternal}
      setIsOpen={setIsOpen}
      restoreFocusSourceAttributes={restoreFocusSourceAttributes}
    />
  );
};

GoalDetailSettingEditDrawer.propTypes = {
  activity: PropTypes.shape({
    trace: PropTypes.func.isRequired,
    error: PropTypes.func.isRequired,
  }),
  goal: PropTypes.shape(GoalPropType).isRequired,
  isOpen: PropTypes.bool.isRequired,
  isReadOnly: PropTypes.bool,
  serverContext: PropTypes.shape({
    CurrentAccount: PropTypes.object.isRequired,
    CurrentCustomer: PropTypes.object.isRequired,
  }).isRequired,
  setGoal: PropTypes.func.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  restoreFocusSourceAttributes: PropTypes.shape({}),
};

GoalDetailSettingEditDrawer.defaultProps = {
  activity: {
    trace: _.noop,
    error: _.noop,
  },
  isReadOnly: false,
  restoreFocusSourceAttributes: {},
};
